import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Observable } from  "rxjs";
import { map } from 'rxjs/operators';
import { AuthService } from './Auth/auth.service';
import { ConstantsService } from './Constants/constants.service';

@Injectable({
  providedIn: 'root'
})
export class MasterService {
  private service_URL: any;
  constructor(private httpClient:HttpClient,private authService: AuthService) { 
    this.service_URL=ConstantsService
  }
  globalHeaders(): any {
  //   let headers = new HttpHeaders({
  //     'Content-Type': 'application/json'            
  //  });
    let headers: HttpHeaders = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE');
    headers.append('Access-Control-Allow-Headers', 'Content-Type');
    let options = { headers: headers };
    return options;

  }

  private handleError(error: any): Promise<any> {
    return Promise.reject(error.messgae || error);
  }
  getOfficeMasterData() :Observable<any>
  {
    return this.httpClient.get(this.service_URL.Master.officeMasterData,{headers: <HttpHeaders> this.authService.GetHttpHeader() }).pipe(map((response) => {
      //return this.setUserEmployeeRoles(response);
      return response;
    }));  
  }
  getCityMasterData(): Observable<any> {
    return this.httpClient.get(this.service_URL.Master.CityMasterData, { headers: <HttpHeaders>this.authService.GetHttpHeader() }).pipe(map((response) => {
      //return this.setUserEmployeeRoles(response);
      return response;
    }));
  }
  getMastersDataUsers() : Observable<any>
  {
    return this.httpClient.get(this.service_URL.Users.getMasterData,{headers: <HttpHeaders> this.authService.GetHttpHeader() }).pipe(map((response) => {
      //return this.setUserEmployeeRoles(response);
      return response;
    }));    
  }
  
  }
